import styled from 'styled-components';

import { getSpacingVar } from './Spacing';
import type { BoxProps } from './SpacingLayout.types';

const toPx = (prop?: string | number) => (typeof prop === 'number' ? `${prop}px` : prop);

type StyledProps = {
    [K in keyof BoxProps as `$${K}`]: BoxProps[K];
};

export const LayoutBox = styled.div<StyledProps>`
    display: ${t => (t.$inline ? 'inline-flex' : 'flex')};
    flex-direction: ${t => (t.$column ? 'column' : 'row')};
    gap: ${t => getSpacingVar(t.$gap!)};
    align-items: ${t => (t.$center ? 'center' : 'normal')};
    width: ${t => (t.$fullWidth ? '100%' : undefined)};
    min-width: ${t => toPx(t.$minWidth)};
    max-width: ${t => toPx(t.$maxWidth)};
    min-height: ${t => toPx(t.$minHeight)};
    max-height: ${t => toPx(t.$maxHeight)};
    margin: ${t => t.$m};
    margin-top: ${t => toPx(t.$mt)};
    margin-right: ${t => toPx(t.$mr)};
    margin-bottom: ${t => toPx(t.$mb)};
    /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
    margin-left: ${t => toPx(t.$ml)};
    padding: ${t => t.$p};
    padding-top: ${t => toPx(t.$pt)};
    padding-right: ${t => toPx(t.$pr)};
    padding-bottom: ${t => toPx(t.$pb)};
    /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
    padding-left: ${t => toPx(t.$pl)};
`;
